import Session from 'session-plugin/lib/classes/Session'

const sessionMixin = {
  computed: {
    $s () {
      const s = window.$s || new Session({ router: this.$router })
      return s
    }
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      await vm.$s.ready
      vm.$s.refresh()
      vm.$s.guard(vm)
      next()
    })
  },
  async beforeRouteUpdate (to, from, next) {
    this.$s.ready
    this.$s.refresh()
    this.$s.guard(this, next)
  },
  created () {
      this.$router && (this.$s.$router = this.$router)
    }
  }
  
  export default sessionMixin
